import fetchSections from './fetchSections';
import updateSection from './updateSection';
import updateChild from './updateChild';
import moveSection from './moveSection';
import addChild from './addChild';
import addSection from './addSection';
import deleteSection from './deleteSection';
import softDeleteSection from './softDeleteSection';
import deleteChild from './deleteChild';
import moveChild from './moveChild';
import fetchTrash from './fetchTrash';
import restoreSection from './restoreSection';
import emptyTrash from './emptyTrash';

export default {
  fetchSections,
  updateSection,
  updateChild,
  moveSection,
  addChild,
  addSection,
  deleteSection,
  softDeleteSection,
  deleteChild,
  moveChild,
  fetchTrash,
  restoreSection,
  emptyTrash,
};
